import { useEffect, useState } from 'react'

import { debounce } from 'lodash'

interface UseDebouncedValueProps<T> {
    initialValue: T
    delay: number
}

export const useDebouncedValue = <T,>(props: UseDebouncedValueProps<T>): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(props.initialValue)

    useEffect(() => {
        const debouncedUpdate = debounce((val: T) => {
            setDebouncedValue(val)
        }, props.delay)

        debouncedUpdate(props.initialValue)

        return () => debouncedUpdate.cancel()
    }, [props.initialValue, props.delay])

    return debouncedValue
}
